import React from 'react';

import { FavoriteButton } from 'modules';

import * as dataService from './dataService';



interface IProps {
  investorUserId: string;
  isFavorited?: boolean;

  onClick?: () => void;
  onError?: () => void;
}

export const FavoriteInvestorButton: React.FC<IProps> = props => {
  const { mutations, loading } = dataService.useFavoriteInvestor();

  const [isFavorited, setIsFavorited] = React.useState(props.isFavorited ?? false);



  const handleClickFavorite = React.useCallback(async () => {
    const prevFavorited = isFavorited;

    try {
      setIsFavorited(!prevFavorited);
      await mutations.favoriteInvestor(props.investorUserId, !props.isFavorited);
      if (props.onClick) {
        props.onClick();
      }

    } catch (e) {
      if (props.onError) {
        props.onError();
      }
      setIsFavorited(prevFavorited);
    }
  }, [isFavorited, mutations, props]);



  return (
    <FavoriteButton.FC
      favorited={isFavorited}
      disabled={loading}
      onClick={handleClickFavorite} />
  );
};
